<div class="address-details">
    <div class="address-details__company-name" [mmTestTarget]="'company-name'">
        {{ address?.companyName }}
    </div>
    <div>
        <span [mmTestTarget]="'first-name'">
            {{ address.firstName }}
        </span> <span [mmTestTarget]="'last-name'">
            {{ address.lastName }}
        </span>
    </div>
    <div>
        <span [mmTestTarget]="'street'">{{ address.street }}</span>
        <span *ngIf="address.street && address.houseNumber">, </span>
        <span [mmTestTarget]="'house-number'">{{ address.houseNumber }}</span>
    </div>
    <div [mmTestTarget]="'address-line-2'">{{ address.addressLine2 }}</div>
    <div>
        <span [mmTestTarget]="'postal-code'">{{ address.postalCode }}</span>
        <span *ngIf="address.city && address.postalCode">&nbsp;</span>
        <span [mmTestTarget]="'city'">{{ address.city }}</span>
    </div>
    <div [mmTestTarget]="'country'">{{ address.countryName }}</div>
</div>
